import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import * as Actions from '../actions/SurveyManagement';

const getSurveyReducer = handleActions({
    [Actions.GetSurveyRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.GetSurveyReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
    }),
    [Actions.GetSurveyReceiveFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
    }),
    [Actions.ClearGetSurvey]: () => ({
        isFetching: false,
        data: {},
        errors: {},
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
});

const updateSurveyReducer = handleActions({
    [Actions.UpdateSurveyRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.UpdateSurveyReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
        success: true,
    }),
    [Actions.UpdateSurveyReceiveFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
        success: false,
    }),
    [Actions.ClearUpdateSurvey]: () => ({
        isFetching: false,
        data: {},
        errors: {},
        success: false,
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
    success: false,
});

export default combineReducers({
    getSurvey: getSurveyReducer,
    updateSurvey: updateSurveyReducer,
});
